import React, { useEffect, useState, useRef } from "react";
import { Typography } from "@material-ui/core";
import { Image } from "react-bootstrap";
import { useReactToPrint } from "react-to-print";
import { formatDate } from "../../utils/utils";
import html2pdf from "html2pdf.js";
import DialogLayout from "../../partials/content/DialogLayout";
import { DialogActions } from "@material-ui/core";
import "./customPosReceipt.scss";
import NumberFormat from "react-number-format";
import { DateTime } from "luxon";
import { useGlobalData } from "../../../provider/GlobalDataProvider";
import {
  getSharedDocuments,
  uploadSharedDocument,
} from "../../services/commons";
import copy from "clipboard-copy";
import Swal from "sweetalert2";
import BootstrapTooltip from "./BootstrapTooltip";
import { CustomOutlinedDisabledTextField } from "./Forms";
function CustomPosReceipt({
  salesData = {},
  outletData = {},
  userName = "",
  currentDateTime = DateTime.now(),
}) {
  const { companyProfile, reload } = useGlobalData();
  const styledTypography = {
    fontFamily: ["sans-serif"].join(","),
    fontWeight: "normal",
    lineHeight: "normal",
    color: "rgb(0, 0, 0)",
  };
  const [openSharedDocument, setOpenSharedDocument] = useState(false);
  const [sharedDocumentLink, setSharedDocumentLink] = useState("");
  const timestamp = DateTime.now().toFormat("yyyy-MM-dd, hh:mm a ZZZZZ (ZZZZ)");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [isCopySucceed, setIsCopySucceed] = useState(false);
  const [whatsappNumber, setWhatsappNumber] = useState("");

  useEffect(() => {
    setFrom(companyProfile.companyName);
    if (salesData.customerID > 0) {
      setTo(salesData.customerName);
    }
    if (salesData.addressPhone !== "") {
      setWhatsappNumber(salesData.addressPhone);
    }
  }, [reload]);

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle:
      "@page { size: auto !important; margin: none !important; } @media print { body { -webkit-print-color-adjust: exact; } }",
    documentTitle: `Receipt_${from}_${to}_${formatDate(currentDateTime, true)}`,
  });

  const handleSharePDF = () => {
    let fileName = `Receipt_${from}_${to}_${formatDate(
      currentDateTime,
      true
    )}.pdf`;
    let fileNameConverted = fileName.replace(/ /g, "").replace(/:/g, "");
    var opt = {
      margin: 0,
      filename: `Receipt_${from}_${to}_${formatDate(
        currentDateTime,
        true
      )}.pdf`,
      image: { type: "jpeg", quality: 1 },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
      html2canvas: {
        scale: 2,
        letterRendering: true,
        allowTaint: true,
        useCORS: true,
      },
      jsPDF: {
        unit: "in",
        format: "ledger",
        orientation: "portrait",
        putOnlyUsedFonts: true,
        compress: true,
      },
    };
    var element = componentRef.current;
    html2pdf()
      .from(element)
      .set(opt)
      .toPdf()
      .get("pdf")
      .output("datauristring")
      .then(function(pdf) {
        const filesData = new FormData();
        const preBlob = dataURItoBlob(pdf);
        const file = new File([preBlob], fileNameConverted, {
          type: "application/pdf",
        });
        filesData.append("files[]", file);
        filesData.append("docID", salesData.ID);
        filesData.append("docType", "POSL");
        uploadSharedDocument(filesData).then((response) => {
          getSharedDocumentData("POSL", salesData.ID);
          setOpenSharedDocument(true);
        });
      });
  };

  function dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(",")[0].indexOf("base64") >= 0)
      byteString = atob(dataURI.split(",")[1]);
    else byteString = unescape(dataURI.split(",")[1]);

    // separate out the mime component
    var mimeString = dataURI
      .split(",")[0]
      .split(":")[1]
      .split(";")[0];

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
  }

  return (
    <React.Fragment>
      <div className="row justify-content-center py-2 px-2 py-md-2 px-md-0">
        <div className="col-md-10">
          <div className="d-flex justify-content-between">
            <button
              type="button"
              className="btn btn-label-primary btn-md btn-pill btn-bold"
              onClick={handleSharePDF}
            >
              <i className="fas fa-share-alt"></i>
              Share Receipt
            </button>
            <button
              type="button"
              className="btn btn-label-info btn-md btn-pill btn-bold"
              onClick={handlePrint}
            >
              <i className="fas fa-print"></i>
              Print Receipt
            </button>
          </div>
        </div>
      </div>
      <div className="d-flex flex-column-fluid">
        <div className="container">
          <div className="card card-custom overflow-hidden">
            <div className="card-body p-0">
              <div className="row justify-content-center">
                <div
                  ref={componentRef}
                  id="invoice-POS"
                  style={{
                    width: `${
                      outletData.thermalPrinterSizeName
                        ? outletData.thermalPrinterSizeName
                        : "58mm"
                    }`,
                  }}
                >
                  <div className="d-flex justify-content-center py-1 py-md-1">
                    <div className="d-flex flex-column flex-root text-wrap">
                      <div className="text-center">
                        <div className="mb-2">
                          <Image
                            src={
                              companyProfile.companyProfileLogo.length > 0
                                ? companyProfile.companyProfileLogo[0].imagePath.includes(
                                    "?"
                                  )
                                  ? `${companyProfile.companyProfileLogo[0].imagePath}&v=${timestamp}`
                                  : `${companyProfile.companyProfileLogo[0].imagePath}?v=${timestamp}`
                                : "/media/logos/logo-form-header.png"
                            }
                            style={{
                              maxHeight: "50px",
                            }}
                            alt="Company Profile Logo"
                            fluid
                            crossOrigin="anonymous"
                          />
                        </div>
                        <div className="info">
                          <Typography
                            style={styledTypography}
                            align="center"
                            variant="h6"
                            className="mb-2"
                          >
                            <strong>
                              {outletData.outletName
                                ? outletData.outletName
                                : companyProfile.companyName}
                            </strong>
                          </Typography>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-center py-1 py-md-1">
                    <div className="d-flex flex-column flex-root text-wrap">
                      <Typography
                        style={styledTypography}
                        align="center"
                        variant="subtitle1"
                      >
                        <strong>Address:</strong> {outletData.fullAddress}
                      </Typography>
                      <Typography
                        style={styledTypography}
                        align="center"
                        variant="subtitle1"
                      >
                        <strong>Email:</strong> {outletData.addressEmail}
                      </Typography>
                      <Typography
                        style={styledTypography}
                        align="center"
                        variant="subtitle1"
                      >
                        <strong>Phone:</strong> {outletData.addressPhone}
                      </Typography>
                    </div>
                  </div>
                  <div className="row justify-content-center py-1 py-md-1">
                    <div className="col-md-12">
                      <div id="table" className="table-responsive">
                        <table className="table">
                          <thead>
                            <tr>
                              <th className="border-top border-bottom-0 border-2 border-dark pl-0 py-1">
                                <Typography
                                  style={styledTypography}
                                  variant="subtitle1"
                                >
                                  ID {salesData.ID}
                                </Typography>
                              </th>
                              <th className="border-top border-bottom-0 border-2 border-dark pr-0 py-1">
                                <Typography
                                  style={styledTypography}
                                  variant="subtitle1"
                                  className="text-right"
                                >
                                  {userName}
                                </Typography>
                              </th>
                            </tr>
                          </thead>
                        </table>
                        <table className="table">
                          <thead>
                            <tr>
                              <th className="border-bottom-0 border-2 border-dark pl-0 py-1">
                                <Typography
                                  style={styledTypography}
                                  variant="subtitle1"
                                >
                                  {formatDate(currentDateTime, true, false)}
                                </Typography>
                              </th>
                              <th className="border-bottom-0 border-2 border-dark pr-0 py-1">
                                <Typography
                                  style={styledTypography}
                                  variant="subtitle1"
                                  className="text-right"
                                >
                                  In {salesData.currencyCode}
                                </Typography>
                              </th>
                            </tr>
                          </thead>
                        </table>
                        <table className="table">
                          <thead>
                            <tr>
                              <th className="border-bottom border-top border-2 border-dark pl-0 py-1">
                                <Typography
                                  style={styledTypography}
                                  variant="subtitle1"
                                  className="kt-font-bold"
                                >
                                  ITEM
                                </Typography>
                              </th>
                              <th className="border-bottom border-top border-2 border-dark py-1">
                                <Typography
                                  style={styledTypography}
                                  variant="subtitle1"
                                  className="text-right kt-font-bold"
                                >
                                  PRICE
                                </Typography>
                              </th>
                              <th className="border-bottom border-top border-2 border-dark pr-0 py-1">
                                <Typography
                                  style={styledTypography}
                                  variant="subtitle1"
                                  className="text-right kt-font-bold"
                                >
                                  TOTAL
                                </Typography>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {salesData.salesPosItem &&
                            salesData.salesPosItem.length > 0
                              ? salesData.salesPosItem.map((item, index) => {
                                  return (
                                    <React.Fragment key={index}>
                                      <tr className="kt-font-bold border-bottom-0">
                                        <td className="pl-0 py-1">
                                          <Typography
                                            style={styledTypography}
                                            variant="subtitle1"
                                          >
                                            {item.itemName}
                                          </Typography>
                                        </td>
                                        <td className="py-1">
                                          <Typography
                                            style={styledTypography}
                                            variant="subtitle1"
                                            component="div"
                                            className="text-right"
                                          >
                                            <NumberFormat
                                              value={item.unitPrice}
                                              displayType={"text"}
                                              thousandSeparator={true}
                                              decimalScale={2}
                                              renderText={(value) => (
                                                <span>{`${value} x ${item.qty} ${item.uomName}`}</span>
                                              )}
                                            />
                                          </Typography>
                                        </td>
                                        <td className="pr-0 py-1">
                                          <Typography
                                            style={styledTypography}
                                            variant="subtitle1"
                                            component="div"
                                            className="text-right"
                                          >
                                            <NumberFormat
                                              value={item.totalPrice}
                                              displayType={"text"}
                                              thousandSeparator={true}
                                              decimalScale={2}
                                              renderText={(value) => (
                                                <span>{value}</span>
                                              )}
                                            />
                                          </Typography>
                                        </td>
                                      </tr>
                                    </React.Fragment>
                                  );
                                })
                              : null}
                            <tr className="kt-font-bold border-bottom-0">
                              <td
                                className="border-top border-2 border-dark py-0 py-1"
                                colSpan="2"
                              >
                                <Typography
                                  style={styledTypography}
                                  variant="subtitle1"
                                  className="text-right"
                                >
                                  SUB TOTAL
                                </Typography>
                              </td>
                              <td className="border-top border-2 border-dark pr-0 py-1">
                                <Typography
                                  style={styledTypography}
                                  variant="subtitle1"
                                  component="div"
                                  className="text-right"
                                >
                                  <NumberFormat
                                    value={salesData.subTotal}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    renderText={(value) => <span>{value}</span>}
                                  />
                                </Typography>
                              </td>
                            </tr>
                            <tr className="kt-font-bold border-bottom-0">
                              <td className="border-0 py-0 py-1" colSpan="2">
                                <Typography
                                  style={styledTypography}
                                  variant="subtitle1"
                                  className="text-right"
                                >
                                  TAX
                                </Typography>
                              </td>
                              <td className="border-0 pr-0 py-1">
                                <Typography
                                  style={styledTypography}
                                  variant="subtitle1"
                                  component="div"
                                  className="text-right"
                                >
                                  <NumberFormat
                                    value={salesData.taxAmount}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    renderText={(value) => <span>{value}</span>}
                                  />
                                </Typography>
                              </td>
                            </tr>
                            <tr className="kt-font-bold border-bottom-0">
                              <td className="border-0 py-0 py-1" colSpan="2">
                                <Typography
                                  style={styledTypography}
                                  variant="subtitle1"
                                  className="text-right"
                                >
                                  DISCOUNT
                                </Typography>
                              </td>
                              <td className="border-0 pr-0 py-1">
                                <Typography
                                  style={styledTypography}
                                  variant="subtitle1"
                                  component="div"
                                  className="text-right"
                                >
                                  <NumberFormat
                                    value={salesData.discountAmount}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    renderText={(value) => (
                                      <span>- {value}</span>
                                    )}
                                  />
                                </Typography>
                              </td>
                            </tr>
                            <tr className="kt-font-bold border-bottom-0">
                              <td className="border-0 py-0 py-1" colSpan="2">
                                <Typography
                                  style={styledTypography}
                                  variant="subtitle1"
                                  className="text-right kt-font-bold"
                                >
                                  GRAND TOTAL
                                </Typography>
                              </td>
                              <td className="border-0 pr-0 py-1">
                                <Typography
                                  style={styledTypography}
                                  variant="subtitle1"
                                  component="div"
                                  className="text-right kt-font-bold"
                                >
                                  <NumberFormat
                                    value={salesData.total}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    renderText={(value) => <span>{value}</span>}
                                  />
                                </Typography>
                              </td>
                            </tr>
                            <tr className="kt-font-bold border-bottom-0">
                              <td className="border-0 py-0 py-1" colSpan="2">
                                <Typography
                                  style={styledTypography}
                                  variant="subtitle1"
                                  className="text-right"
                                >
                                  PAID AMOUNT
                                </Typography>
                              </td>
                              <td className="border-0 pr-0 py-1">
                                <Typography
                                  style={styledTypography}
                                  variant="subtitle1"
                                  component="div"
                                  className="text-right"
                                >
                                  <NumberFormat
                                    value={salesData.payAmount}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    renderText={(value) => <span>{value}</span>}
                                  />
                                </Typography>
                              </td>
                            </tr>
                            <tr className="kt-font-bold border-bottom-0">
                              <td className="border-0 py-0 py-1" colSpan="2">
                                <Typography
                                  style={styledTypography}
                                  variant="subtitle1"
                                  className="text-right"
                                >
                                  CHANGE
                                </Typography>
                              </td>
                              <td className="border-0 pr-0 py-1">
                                <Typography
                                  style={styledTypography}
                                  variant="subtitle1"
                                  component="div"
                                  className="text-right"
                                >
                                  <NumberFormat
                                    value={salesData.change}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    decimalScale={2}
                                    renderText={(value) => <span>{value}</span>}
                                  />
                                </Typography>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-center py-1 py-md-1">
                    <div className="d-flex flex-column flex-root text-wrap">
                      <Typography
                        style={styledTypography}
                        align="center"
                        variant="subtitle1"
                      >
                        <strong>Thanks for your purchase!</strong> Payment is
                        expected within 31 days; please process this invoice
                        within that time. Happy shopping again.
                      </Typography>
                    </div>
                  </div>
                  <div className="d-flex justify-content-center py-1 py-md-1">
                    <div className="d-flex flex-column flex-root text-wrap">
                      <Typography
                        style={styledTypography}
                        align="center"
                        variant="subtitle1"
                      >
                        <strong>Powered by Invifo Enterprise</strong>
                      </Typography>
                      <Typography
                        style={styledTypography}
                        align="center"
                        variant="subtitle1"
                      >
                        www.invifo.com
                      </Typography>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DialogLayout
        open={openSharedDocument}
        title={"Shared Document Link"}
        onCloseDialog={() => {
          setOpenSharedDocument(false);
        }}
        //fullScreen={false}
        maxWIdth="sm"
      >
        <React.Fragment>
          <CustomOutlinedDisabledTextField
            label="Shared Document URL Link"
            value={sharedDocumentLink}
          />
        </React.Fragment>
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSharedDocument(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
          <button
            type="button"
            className="btn btn-success btn-md btn-pill btn-bold"
            onClick={(e) => {
              e.preventDefault();
              let message = sharedDocumentLink;
              if (whatsappNumber === "") {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Failed",
                  text: "Customer Whatsapp Number cannot be empty",
                  icon: "error",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
              } else {
                // Regex expression to remove all characters which are NOT alphanumeric
                let number = whatsappNumber
                  .replace(/[^\w\s]/gi, "")
                  .replace(/ /g, "");

                // Appending the phone number to the URL
                let url = `https://web.whatsapp.com/send?phone=${number}`;

                // Appending the message to the URL by encoding it
                url += `&text=${encodeURI(message)}&app_absent=0`;

                // Open our newly created URL in a new tab to send the message
                window.open(url);
              }
            }}
          >
            <i className="flaticon-whatsapp"></i>
            Send To Whatsapp
          </button>
          <BootstrapTooltip
            title="URL Copied"
            open={isCopySucceed}
            onClose={() => {
              setIsCopySucceed(false);
            }}
          >
            <button
              type="button"
              className="btn btn-dark btn-md btn-pill btn-bold"
              onClick={() => {
                copy(sharedDocumentLink).then(() => {
                  setIsCopySucceed(true);
                });
              }}
            >
              <i className="fas fa-copy"></i>
              Copy To Clipboard
            </button>
          </BootstrapTooltip>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );

  async function getSharedDocumentData(docType, docID) {
    const response = await getSharedDocuments(docType, docID);
    const { data } = response.data;
    let sharedDocuments = data.sharedDocuments;
    if (sharedDocuments.length > 0) {
      setSharedDocumentLink(sharedDocuments[0].filePath);
    }
  }
}

export default CustomPosReceipt;
